// CSS style sheets, keep at the top to avoid affecting CSS precedence.
import "vue-toastification/dist/index.css";
import "./assets/styles/layout/index.scss";
import "./assets/styles/_root.scss";
import "./assets/styles/_global.scss";

import "@babel/polyfill";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./routes";
import store from "./store";
import Maska from "maska";
import VueScrollactive from "@/utils/scrollactive";
import { scrollTargetDirective } from "./utils";
import authTokenInterCeptor from "./../api/interceptors/auth-token-iw.interceptor";
import spinnerInterceptor from "./../api/interceptors/spinner.interceptor";
import routeGuards from "./routes/routeGuards";
import { initModal } from "./adapters/ModalAdapter";
import { ToastPlugin, toastPluginOptions } from "@/adapters/toastNotifierAdapter";
import ImageFallback from "./directives/ImageFallback";
import VendorMenuItemDefault from "@/routes/menu/components/menu-list/menu-item/templates/VendorMenuItemDefault.vue";
import errorLoggerAdapter from "../src/adapters/errorLoggerAdapter";
import { addGTMPlugin } from "@/utils/pagesTrack";

const requireComponent = require.context("./components/base/", true, /App[A-Z]\w+\.(vue|js)$/);
const appIsInDevelopmentMode = (process.env.VUE_APP_MODE || "").toLowerCase() !== "production";
const app = createApp(App);

store.dispatch("config/getVersionEnv").then(() => {
  addGTMPlugin(app, router);

  requireComponent.keys().forEach((filePath) => {
    const componentConfig = requireComponent(filePath);
    const componentName = componentConfig.default.name;

    app.component(componentName, componentConfig.default || componentConfig);
  });
  // Register VendorMenuItemDefault as global to be use inside the ModalWrapper
  app.component("VendorMenuItemDefault", VendorMenuItemDefault);

  errorLoggerAdapter.init(app);

  app.use(VueScrollactive);
  initModal(app);

  app.directive("image-fall-back", ImageFallback);
  app.directive("scroll-target", scrollTargetDirective);
  app.use(Maska);
  app.config.performance = appIsInDevelopmentMode;

  authTokenInterCeptor.wrapStore(store);
  authTokenInterCeptor.wrapRouter(router);
  spinnerInterceptor.wrapStore(store);
  routeGuards.wrapStore(store);

  app.use(store);
  app.use(router);
  app.use(ToastPlugin, toastPluginOptions);
  app.mount("#app");
});

export default app;
